export enum ApplicationStage {
  EmailVerification = 'EmailVerification',
  BankAccountVerification = 'BankAccountVerification',
  IncomeSourcesSelection = 'IncomeSourcesSelection',
  SubmitApplication = 'SubmitApplication',
}

export enum ApplicationStep {
  ECOAConsent = 'ECOAConsent',
  Overview = 'Overview',
  BankAccountVerificationSelectMethod = 'BankAccountVerificationSelectMethod',
  BankAccountVerificationLoginConsent = 'BankAccountVerificationLoginConsent',
  BankAccountVerificationVerifyConsent = 'BankAccountVerificationVerifyConsent',
  BankAccountVerificationLoginWidget = 'BankAccountVerificationLoginWidget',
  BankAccountVerificationEnterInformation = 'BankAccountVerificationEnterInformation',
  BankAccountVerificationNotAbleToVerify = 'BankAccountVerificationNotAbleToVerify',
  IncomeSources = 'IncomeSources',
  DocumentsUpload = 'DocumentsUpload',
  SubmitApplication = 'SubmitApplication',
  ManualReview = 'ManualReview',
  SigningDocuments = 'SigningDocuments',
  Funding = 'Funding',
  AdditionalDocumentsUpload = 'AdditionalDocumentsUpload',
  ThankYou = 'ThankYou',
  Rejected = 'Rejected',
  ExpiredApplication = 'ExpiredApplication',
  CounterOffer = 'CounterOffer',
}

export enum PreQualificationStep {
  Offers = 'Offers',
  CreateAccount = 'CreateAccount',
  EmailVerification = 'EmailVerification',
  SignIn = 'SignIn',
}
